import * as React from 'react';
import styled from 'styled-components';
import { variables } from '../utils';

export interface DetailHeaderProps {
  detail: {
    name: string;
    description?: string | undefined | null;
    purpose?: string | undefined | null;
  };
  activeTab: 'DATA' | 'FEED' | 'SETTINGS';
  setActiveTab: (value: 'DATA' | 'FEED' | 'SETTINGS') => void;
}

const TabButton = styled.button.attrs({
  className: 'f6 pointer pb3 flex-none'
})<{ active?: boolean }>`
  color: ${({ active }) => (active ? variables.navy : variables.blue)};
  border-bottom: 1px solid ${({ active }) => (active ? variables.navy : variables.lightGray)};
  &:hover {
    color: ${variables.navy};
  }
`;

const Spacer = () => <div className="w1 bb b--light-gray flex-none" />;

const DetailHeader: React.FC<DetailHeaderProps> = ({ detail, activeTab, setActiveTab }) => (
  <div>
    <div className="flex items-end mb3">
      <h1
        className="flex-auto bb b--light-gray f3 display fw8 lh-solid mv0 pb3 pr2 truncate"
        data-testid="detail-name"
      >
        {detail.name}
      </h1>

      <TabButton
        active={activeTab === 'DATA'}
        onClick={() => setActiveTab('DATA')}
        data-testid="data-button"
      >
        Data
      </TabButton>

      <Spacer />

      <TabButton
        active={activeTab === 'FEED'}
        onClick={() => setActiveTab('FEED')}
        data-testid="feed-button"
      >
        Feed
      </TabButton>

      <Spacer />

      <TabButton
        active={activeTab === 'SETTINGS'}
        onClick={() => setActiveTab('SETTINGS')}
        data-testid="settings-button"
      >
        Settings
      </TabButton>
    </div>

    <div className="flex-ns justify-between w-100 mb4">
      {detail.description && (
        <p className="f6 serif lh-copy measure mt0 mb3 mb0-ns" data-testid="detail-description">
          {detail.description}
        </p>
      )}
      {detail.purpose && (
        <p className="f6 serif lh-copy measure mt0 mb3 mb0-ns" data-testid="detail-purpose">
          {detail.purpose}
        </p>
      )}
    </div>
  </div>
);

export default DetailHeader;
